import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import { motion } from "framer-motion";
import "./SellMusic.css";

const SellMusicHero = ({ headingbefore, mark, headingafter, detail }) => {
  return (
    <section className="sell-music-hero">
      <div className="bg-abstract-lines"></div>
      
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              {headingbefore} <span style={{ background: 'linear-gradient(90deg, #b042ff, #d946ef)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Music</span> <span style={{ background: 'linear-gradient(90deg, #f97316, #fb923c)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Globally</span> <br />
              {headingafter}
            </motion.h1>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              {detail}
            </motion.h2>
            <motion.a
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-get-in-touch"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              Get in touch
              <div className="bg-white rounded-circle d-flex align-items-center justify-content-center text-dark" style={{ width: '24px', height: '24px' }}>
                <BsArrowRight size={14} />
              </div>
            </motion.a>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SellMusicHero;
